import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { App } from 'antd'
import { useTranslation } from 'react-i18next'
import { contextCompanyIdSelector } from '../../../redux/context/company/selectors'
import { updateDeprecationPlan } from '../service/deprecationPlanService'
import { DeprecationPlanPayload } from '../types'
import { deprecationPlanQueryKeys } from '../queries/deprecationPlanQueryKeys'

interface UpdateDeprecationPlanParams {
  id: number
  data: DeprecationPlanPayload
}

export const useUpdateDeprecationPlan = () => {
  const companyId = useSelector(contextCompanyIdSelector)!
  const queryClient = useQueryClient()
  const { t } = useTranslation()
  const { message } = App.useApp()

  return useMutation({
    mutationKey: ['budget', 'deprecationPlan', 'update'],
    mutationFn: ({ id, data }: UpdateDeprecationPlanParams) => updateDeprecationPlan(companyId, id, data),
    onSuccess: () => {
      message.success(t('messages:updateSuccess', 'Updated successfully'))
      // Note: Financial statements invalidation is handled by global mutation observer
      queryClient.invalidateQueries({ queryKey: deprecationPlanQueryKeys.lists() })
    },
    onError: () => {
      message.error(t('messages:updateError', 'Failed to update'))
    }
  })
}
